import { writable, derived, get } from 'svelte/store';
import type { NvrInfo, StreamInfo } from './types';
import { listNvrs, listStreams } from './api';

export const nvrs = writable<NvrInfo[]>([]);
export const streams = writable<StreamInfo[]>([]);
/** Empty string = "all NVRs". */
export const selectedNvr = writable<string>('');
/** Sidebar collapsed (icon-only) state. */
export const sidebarCollapsed = writable<boolean>(
  typeof localStorage !== 'undefined' && localStorage.getItem('sidebar-collapsed') === '1',
);
sidebarCollapsed.subscribe((v) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('sidebar-collapsed', v ? '1' : '0');
  }
});

/** Streams matching the current NVR filter. */
export const visibleStreams = derived(
  [streams, selectedNvr],
  ([$streams, $sel]) => ($sel ? $streams.filter((s) => s.nvr_id === $sel) : $streams),
);

let inFlight = false;

export async function refreshAll(): Promise<void> {
  if (inFlight) return;
  inFlight = true;
  try {
    const [s, n] = await Promise.all([listStreams(), listNvrs()]);
    streams.set(s);
    nvrs.set(n);
    // If selected NVR was deleted, fall back to all.
    const sel = get(selectedNvr);
    if (sel && !n.some((x) => x.id === sel)) {
      selectedNvr.set('');
    }
  } finally {
    inFlight = false;
  }
}

export async function refreshNvrs(): Promise<void> {
  try {
    nvrs.set(await listNvrs());
  } catch (_) {
    /* tolerate transient errors during periodic refresh */
  }
}
